import React, { Component } from 'react'
import { connect } from 'react-redux'

import FloatNumberInput from  './UI/FloatNumberInput'

import tooltips from '../constants/tooltips.json'

import {
  sendBarMult,
  storeBarMult
} from '../actions'

class LearnModeBarInfo extends Component {

  render() {
    const {
      lowMults,
      highMults,
      selectedLearnBar,
      learnModeRecording,
      onSetBarMult,
      showTooltips
    } = this.props

    const isSelected = selectedLearnBar !== -1

    return (
      <div className="learn-mode-bar-info">
        <h3>
          Bar{" "}
          <span className="bar-number">
            {selectedLearnBar !== -1 ? selectedLearnBar + 1 : ""}
          </span>{" "}
          Adjust
        </h3>
        <div
          className="learn-mode-info bar-gain"
          data-tip={tooltips["learn-mode-bar-gain"]}
          data-multiline="true"
          data-place="right"
          data-tip-disable={!showTooltips}
        >
          <label>Sensitivity </label>
          <FloatNumberInput
            label="learn-bar-gain"
            min={0.3}
            max={1.99}
            step={0.01}
            precision={2}
            disabled={!isSelected || learnModeRecording}
            onFocus={(e) => e.target.select()}
            onChange={(gain) => {
              onSetBarMult("high", selectedLearnBar, gain);
              console.log(highMults[selectedLearnBar]);
            }}
            value={
              highMults[selectedLearnBar]
                ? (highMults[selectedLearnBar] / 128)
                : 1.00
            }
          />
        </div>
        <div
          className="learn-mode-info on-threshold"
          data-tip={tooltips["learn-mode-bar-on-threshold"]}
          data-multiline="true"
          data-place="right"
          data-tip-disable={!showTooltips}
        >
          <label>On-Threshold</label>
          <FloatNumberInput
            label="learn-on-threshold"
            min={0.01}
            max={1.99}
            step={0.01}
            precision={2}
            disabled={!isSelected || learnModeRecording}
            onFocus={(e) => e.target.select()}
            onChange={(threshold) => {
              onSetBarMult("low", selectedLearnBar, threshold);
            }}
            value={
              lowMults[selectedLearnBar]
                ? (lowMults[selectedLearnBar] / 128)
                : 1.00
            }
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    learnModeRecording: state.editor.learnModeRecording,
    selectedLearnBar: state.editor.selectedLearnBar,
    lowMults: state.learnMode.lowMults,
    highMults: state.learnMode.highMults,
    showTooltips: state.editorPreferences.showTooltips
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onSetBarMult: (mode, bar, mult) => {
      dispatch(sendBarMult(mode, bar, mult, true))
      dispatch(storeBarMult(mode, bar, mult, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LearnModeBarInfo)
